import { Typography } from '@saucelabs/ds-typography';
import React from 'react';
import classnames from 'classnames';

import { ImageType } from '../../global/constants';
import { useVisualSelector } from '../../reduxHooks';
import { selectors } from '../../ducks/diffUi';
import { DiffUiDisplayType } from '../../ducks/diffUi/constants';

export type DiffLabelsTitleProps = React.PropsWithChildren<{
  side: ImageType;
  className?: string;
}>;

export const DiffLabelsTitle: React.FC<DiffLabelsTitleProps> = ({
  side,
  children,
  className,
}) => {
  const { displayType, singleDisplayType } = useVisualSelector(selectors.getDiffUi);

  if (displayType === DiffUiDisplayType.Single && singleDisplayType !== side) {
    return null;
  }

  const needsLeftBorder = (
    displayType === DiffUiDisplayType.SideBySide && side === ImageType.SNAPSHOT
  );

  return (
    <div
      className={classnames(className,
        'bg-white flex flex-row w-full min-w-0 min-h-6 items-center',
        {
          'border-l border-solid border-0 border-gray-200': needsLeftBorder,
        },
      )}
    >
      <div className="flex items-center gap-1 py-1 px-2 w-full">
        <Typography
          className="m-0 font-semibold"
          variant="body-large"
        >
          {side === ImageType.SNAPSHOT ? 'Current' : 'Baseline'}
        </Typography>
        {children}
      </div>
    </div>
  );
};
export default DiffLabelsTitle;
